var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import customBreakPoints, { query } from './const/customBreakPoints';
var PageWrapper = styled.main(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 1036px;\n  min-height: 50vh;\n\n  @media ", " {\n    width: 100%;\n  }\n\n  @media ", " {\n    display: flex;\n    justify-content: center;\n  }\n"], ["\n  width: 1036px;\n  min-height: 50vh;\n\n  @media ", " {\n    width: 100%;\n  }\n\n  @media ", " {\n    display: flex;\n    justify-content: center;\n  }\n"])), customBreakPoints.desktopBreakpoint, query.lessThanMedium);
export default PageWrapper;
var templateObject_1;
